namespace OSF {
  export enum ExtendedManifestSupportTokens {
    Requirements = "RequirementsToken",
    Locale = "LocaleToken",
    TokenReplaceRegex = "\\$\\{token\\.(\\w+)\\}",
    ResourceTokenRegEx = "^\\$\\{resource\\.([A-Za-z0-9_-]+)\\}$",
    ExtendedManifestLoggingPrefix = "Extended Manifest",
    ExtendedManifestResourcesLoggingPrefix = "Extended Manifest Resources",
    ActionIdMaxLength = 32,
    ActionNameMaxLength = 125,
  }
  export enum SdxAssetIds {
    Ideas = "fa000000029",
    ExperimentationSdx = "fa000000059",
    CopilotChatExcel = "fa000000124",
    CopilotChatWord = "fa000000125",
    CopilotChatOneNote = "fa000000128",
    CopilotChatPpt = "fa000000129",
  }
  export const DefaultAllowDisplayCaptureSdxIds = [
    SdxAssetIds.CopilotChatExcel,
    SdxAssetIds.CopilotChatWord,
    SdxAssetIds.CopilotChatOneNote,
    SdxAssetIds.CopilotChatPpt,
  ].join(";");
  export enum HostFeatureGateFlags {
    None = 0,
    Enable3rdPartySetAppContextInIFrameName = 0x02,
  }
  export let MaxAppContextLength = 10240;
  export enum HostInfoFlags {
    None = 0,
    SharedApp = 1,
    CustomFunction = 2,
    ProtectedDocDisable = 4,
    ExperimentJsEnabled = 8,
    PublicAddin = 0x10,
    // BundleJsEnabled = 0x20
    IsMos = 0x40,
    IsMonarch = 0x80,
  }

  // only for OMEX
  export enum ManifestRequestTypes {
    Manifest = 1,
    Etoken = 2,
    Both = 3,
  }
  export enum ActivationTypes {
    V1Enabled = 0,
    V1S2SEnabled = 1,
    V2Enabled = 2,
    V2S2SEnabled = 3, // only for OMEX
  }
  export const enum InitialDisplayMode {
    Unknown = 0,
    Hidden = 1,
    Taskpane = 2,
    Dialog = 3,
  }
  export enum InvokeResultCode {
    "S_OK" = 0,
    "E_REQUEST_TIME_OUT" = -2147471590,
    "E_USER_NOT_SIGNED_IN" = -2147208619,
    "E_CATALOG_ACCESS_DENIED" = -2147471591,
    "E_CATALOG_REQUEST_FAILED" = -2147471589,
    "E_OEM_NO_NETWORK_CONNECTION" = -2147208640,
    "E_PROVIDER_NOT_REGISTERED" = -2147208617,
    "E_OEM_CACHE_SHUTDOWN" = -2147208637,
    "E_OEM_REMOVED_FAILED" = -2147209421,
    "E_CATALOG_NO_APPS" = -1,
    "E_USER_NO_MAILBOX" = -2,
    "E_GENERIC_ERROR" = -1000,
    "S_HIDE_PROVIDER" = 10,
  }

  // These codes are for different notification scenarios. And most of them are shared with rich client.
  export enum ErrorStatusCodes {
    E_OEM_EXTENSION_NOT_ENTITLED = 2147758662,
    E_MANIFEST_SERVER_UNAVAILABLE = 2147758672,
    E_USER_NOT_SIGNED_IN = 2147758677,
    E_MANIFEST_DOES_NOT_EXIST = 2147758673,
    E_OEM_EXTENSION_KILLED = 2147758660,
    E_OEM_OMEX_EXTENSION_KILLED = 2147758686,
    E_MANIFEST_UPDATE_AVAILABLE = 2147758681,
    S_OEM_EXTENSION_TRIAL_MODE = 275013,
    E_OEM_EXTENSION_WITHDRAWN_FROM_SALE = 2147758690,
    E_TOKEN_EXPIRED = 2147758675,
    E_TRUSTCENTER_CATALOG_UNTRUSTED_ADMIN_CONTROLLED = 2147757992,
    E_MANIFEST_REFERENCE_INVALID = 2147758678,
    S_USER_CLICKED_BUY = 274205,
    E_MANIFEST_INVALID_VALUE_FORMAT = 2147758654,
    E_TRUSTCENTER_MOE_UNACTIVATED = 2147757996,
    S_OEM_EXTENSION_FLAGGED = 275040,
    S_OEM_EXTENSION_DEVELOPER_WITHDRAWN_FROM_SALE = 275041,
    E_BROWSER_VERSION = 2147758194,
    E_TRUSTCENTER_APP_BLOCKED_FOR_MINOR = -2147209295,
    E_PRIVACY_SERVICE_DISABLED_ADMIN = 2147758792,
    WAC_AgaveUnsupportedStoreType = 1041,
    WAC_AgaveActivationError = 1042,
    WAC_ActivateAttempLoading = 1043,
    WAC_HTML5IframeSandboxNotSupport = 1044,
    WAC_AgaveRequirementsErrorOmex = 1045,
    WAC_AgaveRequirementsError = 1046,
    WAC_AgaveOriginCheckError = 1047,
    WAC_AgavePermissionCheckError = 1048,
    WAC_AgaveHostHandleRequestError = 1049,
    WAC_AgaveUnknownClientAppStatus = 1050,
    WAC_AgaveAnonymousProxyCreationError = 1051,
    WAC_AgaveOsfControlActivationError = 1052,
    WAC_AgaveEntitlementRequestFailure = 1053,
    WAC_AgaveManifestRequestFailure = 1054,
    WAC_AgaveManifestAndEtokenRequestFailure = 1055,
    WAC_FirstPartyAddInListRequestFailure = 1056,
    //WAC_SSOAddinRequireConsent: 1057, // OMEX Consent flow removed
    WAC_SDX_DMSRequestFailed = 1058,
    WAC_SDX_AssetIdNotInDMSResponse = 1059,
    WAC_CustomFunctionsRegistrationError = 1060,
    WAC_WopiHostCheckStatusNotTrusted = 1061,
    WAC_WopiHostCheckStatusNotReady = 1062,
    WAC_AgaveIRMBlockError = 1063, // IRM encryption setting blocking non-1st party agave activation
  }

  // Parameter value for createStream method
  export enum BWsaConfig {
    defaultMaxStreamRows = 1000,
  }

  // Parameter value for createStream method
  export enum BWsaStreamTypes {
    Static = 1,
  }

  // The definition of these values are also inside \\offsos1\dev15\otools\inc\sqm\sqmdata.cs
  export enum SQMDataPoints {
    DATAID_APPSFOROFFICEUSAGE = 10595,
    DATAID_APPSFOROFFICENOTIFICATIONS = 10942,
  }
  export enum ClientAppInfoReturnType {
    urlOnly = 0,
    etokenOnly = 1,
    both = 2,
  }

  // The following values of object below have to match those of enum HostFrameTrustState
  // in % SRCROOT %\msoserviceplatform\src\Browser\App\Scripts\AFrameworkApplication.cs
  /// <summary>
  /// Different possible values for IsHostFrameTrusted
  /// </summary>
  export enum HostFrameTrustState {
    /// <summary>
    /// Default, we haven't checked WOPI UI capablity yet, we are waiting to activate Add-Ins
    /// </summary>
    NotInitialized = 0,
    /// <summary>
    /// we are not activating Add-Ins
    /// </summary>
    NotImplemented = 1,
    /// <summary>
    /// Host indicated via WOPI UI capability it can handle the message, but no response yet. We are waiting to activate Add-ins.
    /// </summary>
    NotReady = 2,
    /// <summary>
    /// Temporary list of hosts that are exempted from sending Host_IsFrameTrusted, set if HostExemptedFromFrameTrustCheck is true
    /// </summary>
    Exempted = 3,
    /// <summary>
    /// Host has failed the trust check as it has been embedded without its consent
    /// </summary>
    NotTrusted = 4,
    /// <summary>
    /// Host confirmed via Host_IsFrameTursted post message that its embedded in its own domain
    /// </summary>
    Trusted = 5,
  }
  export enum UpnCheckCode {
    NotSet = 0,
    Match = 1,
    NotMatch = 2,
  }
  export enum ProxyCallStatusCode {
    Succeeded = 1,
    Failed = 0,
    ProxyNotReady = -1,
  }
  export enum FormFactor {
    Default = "DefaultSettings",
    Desktop = "DesktopSettings",
    Tablet = "TabletSettings",
    Phone = "PhoneSettings",
  }

  // Enum for OsfControl type
  export enum OsfControlTarget {
    Undefined = -1,
    InContent = 0,
    TaskPane = 1,
    Contextual = 2,
    SDXDialog = 3,
  }
  export enum OfficeAppType {
    ContentApp = OSF.OsfControlTarget.InContent,
    TaskPaneApp = OSF.OsfControlTarget.TaskPane,
    MailApp = OSF.OsfControlTarget.Contextual,
    SDXDialogApp = OSF.OsfControlTarget.SDXDialog,
  }
  export enum OmexRemoveAppStatus {
    Failed = 0,
    Success = 1,
  }
  export enum OmexAuthNStatus {
    NotAttempted = -1,
    CheckFailed = 0,
    Authenticated = 1,
    Anonymous = 2,
    Unknown = 3,
  }
  export enum OmexEntitlementType {
    Free = "free",
    Trial = "trial",
    Paid = "paid",
  }
  export enum OmexTrialType {
    None = 0,
    Office = 1,
    External = 2,
  }
  export enum OmexState {
    Killed = 0,
    OK = 1,
    Withdrawn = 2,
    Flagged = 3,
    DeveloperWithdrawn = 4,
  }
  export enum OmexClientAppStatus {
    OK = 1,
    UnknownAssetId = 2,
    KilledAsset = 3,
    NoEntitlement = 4,
    DownloadsExceeded = 5,
    Expired = 6,
    Invalid = 7,
    Revoked = 8,
    ServerError = 9,
    BadRequest = 10,
    LimitedTrial = 11,
    TrialNotSupported = 12,
    EntitlementDeactivated = 13,
    VersionMismatch = 14,
    VersionNotSupported = 15,
    UserIsMinor = 16,
  }
  export enum ManifestIdIssuer {
    Microsoft = "Microsoft",
    Custom = "Custom",
  }

  // Please keep this mapping in sync with the server-side enum OsfStoreType
  // defined in OemExternalTypes.h and the StoreType above.
  export enum StoreTypeEnum {
    MarketPlace = 0,
    Catalog = 1,
    SPApp = 2,
    Exchange = 3,
    FileSystem = 4,
    Registry = 5,
    //   OneDrive = 9, // OneDrive Catalog was an experiment and is no longer supported.
    PrivateCatalog = 10,
    HardCodedPreinstall = 11,
    FirstParty = 12,
    Sdx = 14,
    UploadFileDevCatalog = 15,
    WopiCatalog = 16,
    MosExtra = 18,
  }

  // Please keep this mapping in sync with the server-side enum OsfStoreType
  // defined in OemExternalTypes.h and the StoreTypeEnum below.
  export enum StoreType {
    OMEX = "omex",
    SPCatalog = "spcatalog",
    SPApp = "spapp",
    Exchange = "exchange",
    FileSystem = "filesystem",
    Registry = "registry",
    InMemory = "inmemory",
    //    OneDrive = "onedrive", // OneDrive Catalog was an experiment and is no longer supported.
    PrivateCatalog = "excatalog",
    HardCodedPreinstall = "hardcodedpreinstall",
    FirstParty = "firstparty",
    UploadFileDevCatalog = "uploadfiledevcatalog",
    Sdx = "sdxcatalog",
    WopiCatalog = "wopicatalog",
    MosExtra = "mosextra",
  }

  // Enum for OsfControl add-in page status
  export enum OsfControlPageStatus {
    NotStarted = 1,
    Loading = 2,
    Ready = 3,
    FailedHandleRequest = 4,
    FailedOriginCheck = 5,
    FailedPermissionCheck = 6, // Activation failed at permission check
  }

  // Enum for OsfControl status
  export enum OsfControlStatus {
    NotActivated = 1,
    Activated = 2,
    AppStoreNotReachable = 3,
    InvalidOsfControl = 4,
    UnsupportedStore = 5,
    UnknownStore = 6,
    ActivationFailed = 7,
    NotSandBoxSupported = 8,
  }

  // Enum for OsfControl permission
  export enum OsfControlPermission {
    Restricted = 1,
    ReadDocument = 2,
    WriteDocument = 4,
    ReadItem = 32,
    ReadWriteMailbox = 64,
    ReadAllDocument = 131,
    ReadWriteDocument = 135, // ReadDocument | WriteDocument | ReadAllDocument
    ReadWriteItem = 256,
  }

  //Capability in manifest
  export enum Capability {
    Mailbox = "Mailbox",
    Document = "Document",
    Workbook = "Workbook",
    Project = "Project",
    Presentation = "Presentation",
    Database = "Database",
    Sway = "Sway",
    Notebook = "Notebook",
    Drawing = "Drawing",
  }
  export enum HostCapability {
    Excel = OSF.Capability.Workbook,
    Outlook = OSF.Capability.Mailbox,
    Access = OSF.Capability.Database,
    PowerPoint = OSF.Capability.Presentation,
    Word = OSF.Capability.Document,
    Sway = OSF.Capability.Sway,
    OneNote = OSF.Capability.Notebook,
    Visio = OSF.Capability.Drawing,
  }

  // Maps app host type to manifest host type.
  export let getManifestHostType = function OSF$getManifestHostType(hostType) {
    var manifestHostType;
    switch (hostType) {
      case OSF.HostType.Excel:
        manifestHostType = OSF.ManifestHostType.Workbook;
        break;
      case OSF.HostType.Word:
        manifestHostType = OSF.ManifestHostType.Document;
        break;
      case OSF.HostType.PowerPoint:
        manifestHostType = OSF.ManifestHostType.Presentation;
        break;
      case OSF.HostType.OneNote:
        manifestHostType = OSF.ManifestHostType.Notebook;
        break;
      case OSF.HostType.Outlook:
        manifestHostType = OSF.ManifestHostType.Mailbox;
        break;
      case OSF.HostType.Visio:
        manifestHostType = OSF.ManifestHostType.Drawing;
        break;
      default:
        OsfMsAjaxFactory.msAjaxDebug.trace("Invalid host type.");
        throw "Invalid hostType.";
    }
    return manifestHostType;
  };

  // Maps appName to manifest host type.
  export let getManifestHostTypeFromAppName = function OSF$getModernAppVerCode(appName) {
    var manifestHostType;
    switch (appName) {
      case OSF.AppName.ExcelWebApp:
        manifestHostType = OSF.ManifestHostType.Workbook;
        break;
      case OSF.AppName.PowerpointWebApp:
        manifestHostType = OSF.ManifestHostType.Presentation;
        break;
      case OSF.AppName.WordWebApp:
        manifestHostType = OSF.ManifestHostType.Document;
        break;
      case OSF.AppName.OneNoteWebApp:
        manifestHostType = OSF.ManifestHostType.Notebook;
        break;
      case OSF.AppName.OutlookWebApp:
        manifestHostType = OSF.ManifestHostType.Mailbox;
        break;
      case OSF.AppName.VisioWebApp:
        manifestHostType = OSF.ManifestHostType.Drawing;
        break;
      default:
        OsfMsAjaxFactory.msAjaxDebug.trace("Invalid appName.");
        throw "Invalid appName.";
    }
    return manifestHostType;
  };

  // Maps appName to Omex recognized modern appVercode.
  export let getModernAppVerCode = function OSF$getModernAppVerCode(appName) {
    var appModernVerCode;
    switch (appName) {
      case OSF.AppName.ExcelWebApp:
        appModernVerCode = "WAC_Excel";
        break;
      case OSF.AppName.PowerpointWebApp:
        appModernVerCode = "WAC_PowerPoint";
        break;
      case OSF.AppName.WordWebApp:
        appModernVerCode = "WAC_Word";
        break;
      case OSF.AppName.OneNoteWebApp:
        appModernVerCode = "WAC_OneNote";
        break;
      case OSF.AppName.OutlookWebApp:
        appModernVerCode = "WAC_Outlook";
        break;
      case OSF.AppName.VisioWebApp:
        appModernVerCode = "WAC_Visio";
        break;
      default:
        OsfMsAjaxFactory.msAjaxDebug.trace("Invalid appName.");
        throw "Invalid appName.";
    }
    return appModernVerCode;
  };

  // Maps appName to Omex recognized appVercode.
  export let getAppVerCode = function OSF$getAppVerCode(appName) {
    var appVerCode;
    switch (appName) {
      case OSF.AppName.ExcelWebApp:
        appVerCode = "excel.exe"; // TODO: use what client uses and replace it after figuring out what Xl WAC should use.
        break;
      case OSF.AppName.AccessWebApp:
        appVerCode = "ZAC"; //TODO: ZAC is for Access. Need to make sure if this is right for AccessWebApp since there is no appVerCode for AccessWebApp defined yet.
        break;
      case OSF.AppName.PowerpointWebApp:
        appVerCode = "WAP";
        break;
      case OSF.AppName.WordWebApp:
        appVerCode = "WAW";
        break;
      case OSF.AppName.OneNoteWebApp:
        appVerCode = "WAO";
        break;
      case OSF.AppName.VisioWebApp:
        appVerCode = "WAV";
        break;
      default:
        OsfMsAjaxFactory.msAjaxDebug.trace("Invalid appName.");
        throw "Invalid appName.";
    }
    return appVerCode;
  };

  // Host platform strings for forming host specific filenames
  export enum HostPlatform {
    Web = "Web",
  }

  // Manifest Host type strings
  export enum ManifestHostType {
    Workbook = "Workbook",
    Document = "Document",
    Presentation = "Presentation",
    Notebook = "Notebook",
    Mailbox = "Mailbox",
    Drawing = "Drawing",
  }

  // Host type strings for forming host specific filenames
  export enum HostType {
    Excel = "Excel",
    Outlook = "Outlook",
    Access = "Access",
    PowerPoint = "PowerPoint",
    Word = "Word",
    Sway = "Sway",
    OneNote = "OneNote",
    Visio = "Visio",
  }
  export let OmexAppVersions = (function OSF_OmexAppVersions() {
    var nameMap = {},
      appNameList = OSF.AppName;
    nameMap[appNameList.ExcelWebApp] = OSF.AppVersion.excelwebapp;
    nameMap[appNameList.WordWebApp] = OSF.AppVersion.wordwebapp;
    nameMap[appNameList.OutlookWebApp] = OSF.AppVersion.outlookwebapp;
    nameMap[appNameList.AccessWebApp] = OSF.AppVersion.access;
    nameMap[appNameList.PowerpointWebApp] = OSF.AppVersion.powerpointwebapp;
    nameMap[appNameList.OneNoteWebApp] = OSF.AppVersion.onenotewebapp;
    nameMap[appNameList.VisioWebApp] = OSF.AppVersion.visiowebapp;
    return nameMap;
  })();
  export let OmexClientNames = (function OSF_OmexClientNames() {
    var nameMap = {},
      appNameList = OSF.AppName;
    nameMap[appNameList.ExcelWebApp] = "WAC_Excel";
    nameMap[appNameList.WordWebApp] = "WAC_Word";
    nameMap[appNameList.OutlookWebApp] = "WAC_Outlook";
    nameMap[appNameList.AccessWebApp] = "WAC_Access";
    nameMap[appNameList.PowerpointWebApp] = "WAC_Powerpoint";
    nameMap[appNameList.OneNoteWebApp] = "WAC_OneNote";
    nameMap[appNameList.VisioWebApp] = "WAC_Visio";
    return nameMap;
  })();

  // Http Verbs
  export enum HttpVerb {
    GET = "GET",
    POST = "POST",
    DELETE = "DELETE",
    PUT = "PUT",
  }

  export enum PayloadType {
    OfficeAddin = 1,
    MosAcquisition = 2,
  }

  // MetaOS acquisition/title scope
  export enum TitleScope {
    Public = "Public",
    Tenant = "Tenant",
    User = "User",
  }

  // MetaOS title acquisition state
  export enum AcquisitionAcquiredState {
    Invalid = "invalid",
    Acquired = "acquired",
    Unacquired = "unacquired",
    NeedsConsentForUpgrade = "needsconsentforupgrade",
    Blocked = "blocked",
    EndOfLife = "endoflife",
  }

  // MetaOS supported id type
  export enum MosSupportIdType {
    TitleId = "TitleId",
    AssetId = "AssetId",
    ManifestId = "ManifestId",
  }

  // MetaOS supported elements types
  export declare type MosSupportedElements =
    | "Activities"
    | "AAD"
    | "Bots"
    | "ComposeExtensions"
    | "ConfigurableTabs"
    | "Connectors"
    | "Dynamics"
    | "ExchangeAddIns"
    | "Extensions"
    | "FirstPartyPages"
    | "GraphConnector"
    | "LineOfBusiness"
    | "MeetingExtensionDefinition"
    | "OfficeAddIns"
    | "StaticTabs";

  // VersionOverrides versions
  export enum VersionOverridesNumber {
    V1_0 = 100,
    V1_1 = 101,
    // Add more here, and also in VersionOverridesNamespace below
    Max,
  }

  // VersionOverrides namespaces
  export enum VersionOverridesNamespace {
    V1_0 = "http://schemas.microsoft.com/office/mailappversionoverrides",
    V1_1 = "http://schemas.microsoft.com/office/mailappversionoverrides/1.1",
  }

  // Parser strings
  export enum ParserStrings {
    DesktopFormFactor = "DesktopFormFactor",
    Form = "Form",
    FormSettings = "FormSettings",
    MobileFormFactor = "MobileFormFactor",
    OOfficeApp = "o:OfficeApp",
    RequestedHeight = "RequestedHeight",
    Resources = "Resources",
    SourceLocation = "SourceLocation",
    VersionOverrides = "VersionOverrides",
    Mailappor = "mailappor:",
  }

  export enum PowerPointSlideShowRole {
    Attendee = 0,
    Presenter = 1,
    PrivateViewing = 2,
  }

  export enum PowerPointSlideShowUIHostType {
    "UnifiedApp",
    "MSTeams",
    "TeamsiOS",
    "TeamsAndroid",
    "Unknown",
  }
}
